<div class="my-data-page">
    <div class="my-data-card">
        <h1 class="app-c-heading--h1" translate>myData.title</h1>

        <p class="app-c-body-text--16" translate>myData.description</p>

        <h2 class="app-c-heading--h3" translate>myData.whatsIncludedTitle</h2>
        <ul class="my-data-included-list">
            <li class="app-c-body-text--14" translate>myData.includedProfile</li>
            <li class="app-c-body-text--14" translate>myData.includedMoodchecks</li>
            <li class="app-c-body-text--14" translate>myData.includedAssessments</li>
            <li class="app-c-body-text--14" translate>myData.includedThoughtDiary</li>
            <li class="app-c-body-text--14" translate>myData.includedActionPlans</li>
            <li class="app-c-body-text--14" translate>myData.includedActivities</li>
            <li class="app-c-body-text--14" translate>myData.includedRoomForPositive</li>
            <li class="app-c-body-text--14" translate>myData.includedVideoProgress</li>
            <li class="app-c-body-text--14" translate>myData.includedStoriesProgress</li>
            <li class="app-c-body-text--14" translate>myData.includedBurningQuestionsProgress</li>
            <li class="app-c-body-text--14" translate>myData.includedDemographic</li>
            <li class="app-c-body-text--14" translate>myData.includedBadges</li>
        </ul>

        <p class="app-c-body-text--14 my-data-format-note" translate>
            myData.formatNote
        </p>

        <button
            type="button"
            class="btn btn-primary my-data-download-btn"
            [disabled]="isPreparing"
            (click)="downloadData()">
            <span *ngIf="!isPreparing" translate>myData.downloadButton</span>
            <span *ngIf="isPreparing" translate>myData.preparingButton</span>
        </button>

        <p class="app-c-body-text--12 my-data-privacy-note" translate>
            myData.privacyNote
        </p>
    </div>
</div>
